"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

declare global {
  interface Window {
    adsbygoogle?: unknown[] & { pauseAdRequests?: number };
  }
}

/**
 * Industry-standard Next.js AdSense Route Controller:
 * - Keeps the official AdSense <script> in RootLayout (<head>) so Google's
 *   site-verification crawler, ads.txt checker, and Ad Settings Preview tool
 *   detect the script on the root domain (https://beyondambitionlimited.com/).
 * - Uses Google's official `adsbygoogle.pauseAdRequests` API + DOM route tagging
 *   so Auto Ads ONLY run on `/blog` and `/blog/*`, keeping Homepage, Services,
 *   Portfolio, About, and Contact 100% ad-free.
 */
export default function AdSenseRouteController() {
  const pathname = usePathname();
  const isBlogRoute = pathname === "/blog" || pathname?.startsWith("/blog/");

  useEffect(() => {
    if (typeof window === "undefined") return;

    window.adsbygoogle = window.adsbygoogle || [];

    if (isBlogRoute) {
      document.body.setAttribute("data-ad-route", "blog");
      window.adsbygoogle.pauseAdRequests = 0;
    } else {
      document.body.setAttribute("data-ad-route", "disabled");
      window.adsbygoogle.pauseAdRequests = 1;

      // Clean up any auto-placed ad containers if navigating from /blog to a non-blog page
      const autoPlacedAds = document.querySelectorAll(
        ".google-auto-placed, ins.adsbygoogle[data-ad-status], div.google-revocation-link-placeholder"
      );
      autoPlacedAds.forEach((el) => el.remove());
    }
  }, [isBlogRoute, pathname]);

  return null;
}
